export default __webpack_public_path__ + "static/media/zayed-project-4.cd1ce9aa.jpg";